module.exports = __webpack_public_path__ + "img/union-dark.cd612657.png";